import {
  memo, useEffect, useMemo, useState
} from 'react';

import { Navigate } from 'react-router-dom';

import { styled } from '@mui/material/styles';

import ArtBubble from '#client/components/ArtBubble';
import AuthPageTemplate from '#client/components/Template/AuthPageTemplate';
import { ROUTES } from '#client/manifest';
import { cookiesAvailable } from '#client/utils/cookies';
import {
  available as storageAvailable
} from '#client/utils/storage';

const GenericError = styled(ArtBubble)(() => ({
  margin: '15px auto',
  maxWidth: 460,
  width: '100%'
}));

const minSiteReqsError = [
  'This section of the site requires the use of cookies and local storage. Please be sure these features are enabled in your browser to continue.',
  'If you need assistance, you can contact our team by chat or email them using support@zenbusiness.com.'
];

const MinSiteRequirements = memo(({ children }) => {
  const [shouldRedirect, setShouldRedirect] = useState(true);
  const minSiteReqs = useMemo(() => cookiesAvailable() && storageAvailable('local') && storageAvailable('session'), []);
  useEffect(() => {
    if (!minSiteReqs && shouldRedirect) {
      setShouldRedirect(false);
    }
  }, [minSiteReqs, shouldRedirect]);
  if (!minSiteReqs) {
    return (
      <AuthPageTemplate message="Sign in to your ZenBusiness dashboard">
        {shouldRedirect && <Navigate replace to={ROUTES.unsupported} />}
        <GenericError
          text={minSiteReqsError}
        />
      </AuthPageTemplate>
    );
  }
  return children;
});

MinSiteRequirements.displayName = 'MinSiteRequirements';

export default MinSiteRequirements;
